import { spacing } from "./spacing";

const divPadding = spacing.xl;

export const constants = {
  radius: {
    view: 10,
    button: 50,
  },
  chart: {
    width: 320,
    height: 140,
    barRadius: 2,
  },
  divPadding,
} as const;
